import AspectRatio from '@blocks/AspectRatio'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import PhotoSlider from '@components/sliders/PhotoSlider'
import useSlider from '@hooks/useSlider'
import { colors } from '@styles/vars'
import React from 'react'
import styled, { css } from 'styled-components'

export default function Photo({ data: photo, onClick, toolbar, middle }: Props) {
    const slider = useSlider(PhotoSlider, { photo })

    const handleClick = onClick
        ? () => onClick(photo)
        : slider.open

    return (
        <Grid gap="10px">
            <AspectRatio height={photo.height} width={photo.width}>
                <ImageWrapper>
                    <ImageContainer src={photo.url} onClick={handleClick} />
                    <Toolbar items={toolbar} />
                </ImageWrapper>
            </AspectRatio>
            {middle}
            <Grid gap="5px">
                <PhotoHeading onClick={handleClick}>{photo.title}</PhotoHeading>
                <Flex justifyContent="flex-start"><small>Original: <a href={photo.url} target="_blank">{photo.width}x{photo.height}px</a></small></Flex>
            </Grid>
        </Grid>
    )
}

const Toolbar = ({ items }: { items?: Props["toolbar"] }) => {
    if (!items)
        return null

    return (
        <ToolbarWrapper>
            <Flex gap="5px">
                {items.map((item, idx) => (
                    <ToolbarItemWrapper key={idx} onClick={item.onClick}>
                        {item.icon}
                    </ToolbarItemWrapper>
                ))}
            </Flex>
        </ToolbarWrapper>
    )
}

// STYLES
const PhotoHeading = styled.h4<{ onClick?: any }>`
    cursor: ${props => props.onClick ? "pointer" : "auto"};
    overflow: hidden;
    text-overflow: ellipsis;
`

const ToolbarWrapper = styled.div`
    position: absolute;
    right: 15px;
    top: 15px;
`

const ToolbarItemWrapper = styled.div<{ onClick?: any }>`
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border: 1px solid ${colors.border};
    border-radius: 50%;
    cursor: ${props => props.onClick ? "pointer" : "auto"};
    transition: .2s ease-out;

    ${props => props.onClick && css`
        &:hover {
            background: ${colors.white};
        }
    `}

    svg {
        width: 24px;
        height: 24px;
    }
`

const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`

const ImageContainer = styled.div<{ src: string, onClick?: any }>`
    position: relative;
    width: 100%;
    height: 100%;
    background: ${({ src }) => `url(${src}) center center no-repeat`};
    background-size: cover;
    border-radius: 5px;
    cursor: ${props => props.onClick ? "pointer" : "auto"};
`

// TYPES
interface Props extends ArchiveComponentProps<Interfaces.Photo> {
    onClick?: (photo: Interfaces.Photo) => void
    toolbar?: ToolbarItem[]
    middle?: React.ReactNode
}

type ToolbarItem = {
    icon: JSX.Element
    onClick?(): void
}